<template>
  <v-container fluid class="py-0" grid-list-md>
    <v-row justify="center">
      <v-col cols="12" md="9" mx-auto>
        <v-card flat v-if="lAction === 'view'">
          <v-card-title class="px-0 py-2">
            <v-layout row wrap>
              <v-flex xs6>
                <v-text-field
                class="pt-0"
                append-icon="mdi-account-search"
                :placeholder="$vuetify.breakpoint.smAndUp?'Search by Community Name, Phone Number, etc.':'Search'"
                hide-details
                v-model="search"
                outlined
                clearable
                ></v-text-field>
              </v-flex>
              <v-flex class="text-right" xs3>
              <v-chip :class="isClosedCommunity ? 'info dark' : '' " @click="showClosedCommunity()">Show Closed Community</v-chip>
            </v-flex>
              <v-flex xs3>
                <v-download-as
                class="pt-1"
                :headers="commSm"
                :items="commList"
                title="Community List"
                :landscape="true"
                ></v-download-as>
              </v-flex>
            </v-layout>
          </v-card-title>
          <v-card-text class="py-3 px-0">
            <v-layout row wrap>
              <v-flex xs4>
                <v-card>
                  <v-card-title class="pa-2 primary--text grey lighten-4">
                    Total
                  </v-card-title>
                  <v-card-text class="pa-2 text-center display-1">
                    {{commList.length}}
                  </v-card-text>
                </v-card>
              </v-flex>
              <v-flex xs4>
                <v-card :to="{path: '/project'}">
                  <v-card-title class="pa-2 primary--text grey lighten-4">
                    {{($vuetify.breakpoint.smAndUp ? 'Under ' : '') + 'AMC'}}
                  </v-card-title>
                  <v-card-text class="pa-2 text-center display-1">
                    {{projStats.amc}}
                  </v-card-text>
                </v-card>
              </v-flex>
              <v-flex xs4>
                <v-card :to="{path: '/project'}">
                  <v-card-title class="pa-2 primary--text grey lighten-4">
                    {{'Turnkey' + ($vuetify.breakpoint.smAndUp ? ' Projects' : '')}}
                  </v-card-title>
                  <v-card-text class="pa-2 text-center display-1">
                    {{projStats.turnkey}}
                  </v-card-text>
                </v-card>
              </v-flex>
              <v-flex xs12>
                <v-data-table
                :headers="$vuetify.breakpoint.smAndUp?commSm:comm"
                :items="commList"
                hide-default-footer
                disable-pagination
                :mobile-breakpoint="0"
                :search="search"
                sort-by="comm_name"
                class="elevation-3">
                <template slot="item" slot-scope="props">
                  <tr @click="prepareEditComm(props.item)">
                    <td>{{ props.item.comm_name }}</td>
                    <td v-if="$vuetify.breakpoint.smAndUp">{{ props.item.contact_phone || '-' }}</td>
                    <td v-if="$vuetify.breakpoint.smAndUp">{{ props.item.contact_email || '-' }}</td>
                    <td v-if="$vuetify.breakpoint.smAndUp">{{ props.item.no_of_unit || '-' }}</td>
                    <td v-if="$vuetify.breakpoint.smAndUp">{{ props.item.cust_since }}</td>
                  </tr>
                </template>
              </v-data-table>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
      <v-btn
      :style="'position:fixed; ' + ($vuetify.breakpoint.smAndDown?'bottom:20px; right:15px;':'bottom:15px; right:15px;')"
      dark fab fixed color="accent" v-if="lAction === 'view'"
      @click.native="prepareCreate">
      <v-icon>mdi-plus</v-icon>
    </v-btn>

    <v-container v-if="lAction === 'create' || lAction === 'update'" class="pa-0" fluid full-height>
      <v-form ref="shForm" id="form" @submit.prevent="saveCommunity(lAction)">
        <v-card flat>
          <v-card-title class="px-0 py-2">
            {{ handy.startWithUpper(lAction) + ' Community' }}
          </v-card-title>
          <v-card-text class="px-0 py-3">
            <v-layout row wrap>
              <v-flex xs6 class="pt-0">
                <v-text-field
                v-model="lComm.comm_name"
                label="Community Name"
                :rules="[rules.required]"
                hide-details
                maxlength="50"
                ></v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-select
                v-model="lComm.zone_id"
                :items="zoneList"
                label="Zone"
                item-text="zone_name"
                item-value="zone_id"
                hide-details
                ></v-select>
                <div class="text-right">
                  <v-btn class="my-2 ml-2 mr-0" small @click="prepareCreateZone">Create Zone</v-btn>
                </div>
              </v-flex>
              <v-flex xs4>
                <v-select
                v-model="lComm.comm_type"
                label="Type"
                :items="['Apartment', 'Villa', 'Corporate', 'Mall']"
                hide-details
                :rules="[rules.required]"
                ></v-select>
              </v-flex>
              <v-flex xs4>
                <v-select
                v-model="lComm.comm_segment"
                label="Segment"
                :items="['Medium', 'Small', 'Large']"
                hide-details
                ></v-select>
              </v-flex>
              <v-flex xs4>
                <v-text-field
                v-model="lComm.no_of_unit"
                label="No. of Units"
                hide-details
                maxlength="11"
                type="number"
                ></v-text-field>
              </v-flex>

              <v-flex xs12 class="mt-3 comm-img-flex">
                <div id="comm-img-label" class="caption grey--text text--darken-1 mb-1">Community Image</div>
                <div class="d-flex align-center flex-wrap">
                  <div class="comm-img-preview grey lighten-4 d-flex align-center justify-center mr-3 mb-2">
                    <img
                    v-if="commImgPreview"
                    :src="commImgPreview"
                    alt="Community image preview"
                    class="comm-img-preview-img"
                    >
                    <div v-else class="text-center px-2">
                      <v-icon color="grey darken-1" size="36">mdi-image-outline</v-icon>
                      <div class="caption grey--text text--darken-1 mt-1">Upload Community Image</div>
                      <div class="comm-img-hint grey--text text--darken-1">JPG, PNG (Max 5 MB)</div>
                    </div>
                  </div>
                  <div class="mb-2">
                    <input
                    type="file"
                    ref="commImgInput"
                    style="display:none"
                    accept="image/jpeg,image/jpg,image/png"
                    aria-labelledby="comm-img-label"
                    @change="loadCommImgFromFile"
                    >
                    <v-btn small outlined color="accent" @click="pickCommImg" aria-labelledby="comm-img-label">
                      {{ commImgPreview ? 'Change Image' : 'Upload Image' }}
                    </v-btn>
                    <v-btn
                    v-if="commImgPreview"
                    small icon class="ml-1"
                    @click="removeCommImg"
                    aria-label="Remove community image"
                    title="Remove"
                    >
                      <v-icon color="error">mdi-delete-outline</v-icon>
                    </v-btn>
                  </div>
                </div>
              </v-flex>

              <v-flex xs12 class="mt-3">
                <span class="primary--text">Contact Information</span>
              </v-flex>
              <v-flex xs12 class="pt-0">
                <v-text-field
                v-model="lComm.address"
                label="Address"
                :rules="[rules.required]"
                hide-details
                maxlength="150"
                ></v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-text-field
                v-model="lComm.city"
                label="City"
                :rules="[rules.required]"
                hide-details
                maxlength="25"
                ></v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-text-field
                v-model="lComm.pin_code"
                label="PIN"
                hide-details
                maxlength="10"
                type="number"
                ></v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-text-field
                v-model="lComm.district"
                label="District"
                hide-details
                maxlength="25"
                ></v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-select
                v-model="lComm.state"
                :items="countryState"
                label="State"
                item-text="state_name"
                hide-details
                ></v-select>
              </v-flex>
              <v-flex xs6>
                <v-text-field
                v-model="lComm.contact_name"
                label="Contact Name"
                hide-details
                maxlength="50"
                ></v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-text-field
                v-model="lComm.contact_desig"
                label="Designation"
                hide-details
                maxlength="50"
                ></v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-text-field
                v-model="lComm.contact_phone"
                label="Phone"
                :rules="[rules.required]"
                hide-details
                maxlength="15"
                type="number"
                ></v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-text-field
                v-model="lComm.contact_email"
                label="Email"
                hide-details
                maxlength="50"
                ></v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-text-field
                v-model="lComm.pan_no"
                label="PAN Number"
                hide-details
                maxlength="20"
                ></v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-text-field
                v-model="lComm.gst_no"
                label="GST Number"
                hide-details
                maxlength="20"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 flat class="mt-3">
                <span class="primary--text">Community Setting</span>
                <v-flex xs6>
                  <v-checkbox
                  v-model="lComm.show_inactive_user"
                  label="Show Inactive Uniservice App Users"
                  hide-details
                  class="shrink"
                  ></v-checkbox>
                </v-flex>
                <v-flex xs6>
                  <v-select
                  v-model="lComm.comm_status"
                  label="Community Status"
                  :items="['Active', 'Inactive']"
                  hide-details
                  ></v-select>
                </v-flex>
              </v-flex>
              <!-- <v-flex xs12 class="mt-3">
                <span class="primary--text">Smartility Payment Gateway</span>
              </v-flex>
              <v-flex xs12 class="pt-0">
                <v-select
                v-model="lComm.pg_status"
                label="Status"
                :items="['NA', 'Active', 'Inactive']"
                hide-details
                ></v-select>
              </v-flex>
              <v-flex xs6>
                <v-text-field
                v-model="lComm.merchant_id"
                label="Merchant ID"
                hide-details
                maxlength="20"
                ></v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-text-field
                v-model="lComm.merchant_key"
                label="Merchant Key"
                hide-details
                maxlength="20"
                ></v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-text-field
                v-model="lComm.bank_acc_no"
                label="Bank Acc No."
                hide-details
                maxlength="25"
                ></v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-text-field
                v-model="lComm.bank_acc_name"
                label="Bank Acc Name"
                hide-details
                maxlength="250"
                ></v-text-field>
              </v-flex> -->
            </v-layout>
          </v-card-text>
          <v-card-actions>
            <v-btn v-if="lAction === 'update'" @click="deleteComm(lComm)">delete</v-btn>
            <v-spacer></v-spacer>
            <v-btn @click.stop="lAction = 'view'">Close</v-btn>
            <v-btn type="submit" color="accent" :disabled="beingSaved">save</v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-container>

    <!-- create zone -->
    <v-dialog v-model="createZone" persistent max-width="400px">
      <v-form>
        <v-card flat v-if="lZAction === 'view'" scrollable>
          <v-card-title class="title grey lighten-4 py-0">
            <v-layout row wrap>
              <v-flex xs6 class="pa-2 text-left">
                <span>Zone List</span>
              </v-flex>
              <v-flex xs6 class="pa-0 text-right">
                <v-btn small icon @click.stop="createZone = false"><v-icon>mdi-close</v-icon></v-btn>
              </v-flex>
              <v-flex xs12 class="pa-0 text-right">
                <v-btn color="accent" text class="mb-0" style="float: right" @click="createZones">Add New</v-btn>
              </v-flex>
            </v-layout>
          </v-card-title>
          <v-card-text class="pa-0">
            <v-flex xs12 class="mx-auto">
              <v-data-table
              :headers="zoneHead"
              :items="zoneList"
              hide-default-footer
              :mobile-breakpoint="0"
              >
              <template slot="item" slot-scope="props">
                <tr @click="prepareEdit(props.item)">
                  <td>{{ props.item.zone_name }}</td>
                </tr>
              </template>
            </v-data-table>
          </v-flex>
        </v-card-text>
      </v-card>

      <!-- 8. create / edit zone-->
      <v-container v-if="lZAction === 'create' || lZAction === 'update'" class="pa-0" fluid grid-list-md>
        <v-form ref="acForm" @submit.prevent="saveZone(lZAction)">
          <v-card flat class="pa-0">
            <v-card-title class="title pb-0">
              {{ handy.startWithUpper(lZAction) }} Zone
            </v-card-title>
            <v-card-text>
              <v-text-field
              v-model="lZone.zone_name"
              label="Zone name"
              :rules="[rules.required]"
              hide-details
              maxlength="25">
            </v-text-field>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn @click.stop="cancelChanges">Cancel</v-btn>
            <v-btn v-if="lZAction === 'update'" :disabled="beingSaved" @click="deleteZone(lZone)">delete</v-btn>
            <v-btn type="submit" color="accent" :disabled="beingSaved">Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-container>
  </v-form>
</v-dialog>

<!-- snack bar for reporting -->
<v-snackbar :color="sbarCol" v-model="sbar"
:timeout="3000" multi-line><span class="mx-auto">{{ sbarMsg }}</span>
</v-snackbar>
</v-col>
</v-row>
</v-container>
</template>

<script>
import VDownloadAs from './VDownloadAs.vue'
import config from '@/config/app-cfg'
import handy from '@/utils/handy'

export default {
  components:
  {
    'v-download-as': VDownloadAs
  },
  data () {
    return {
      lAction: '',
      sbarMsg: '',
      sbar: false,
      sbarCol: 'error',
      handy: handy,
      rules: handy.rules,
      search: '',
      beingSaved: false,
      commSm: [
        { text: 'Community Name', value: 'comm_name', class: 'pa-2' },
        { text: 'Phone', value: 'contact_phone', class: 'pa-2' },
        { text: 'E-Mail', value: 'contact_email', class: 'pa-2' },
        { text: 'No. Of Units', value: 'no_of_unit', class: 'pa-2' },
        { text: 'Customer Since', value: 'cust_since', class: 'pa-2' }
      ],
      comm: [
        { text: 'Community Name', value: 'comm_name' }
      ],
      commList: [],
      projStats: {},
      lComm: [],
      commImgPreview: '',
      commImgFile: null,
      isCommImgChanged: false,
      lZAction: '',
      createZone: false,
      zoneList: [],
      zoneHead: [
        { text: 'Zones', value: 'zone', sortable: false }
      ],
      countryState: [],
      isClosedCommunity: false
    }
  },
  created () {
    this.$router.currentRoute.meta.title = 'Community List'
    this.loadComm()
    this.loadProjStats()
  },
  mounted () {
    this.lAction = 'view'
  },
  computed: {
    today: function () {
      return handy.formatDBDate(Date())
    }
  },
  methods: {
    msg (m, type = 0) {
      if (type === 0) {
        this.sbarCol = 'error'
      } else if (type === 1) {
        this.sbarCol = 'success'
      } else {
        this.sbarCol = 'info'
      }
      this.sbar = true
      this.sbarMsg = m
    },
    loadComm () {
      // available Community
      var qry = {
        params: {
          vendor_id: config.VENDOR_ID,
          is_with_active_project: false,
          is_closed_community: this.isClosedCommunity
        }
      }
      this.axios.get(config.API_URL + '/getCommunityByVendorId/', qry)
      .then(response => {
        this.commList = response.data
        this.commList.forEach(rec => {
          rec.cust_since = rec.cust_since ? handy.formatDate(rec.cust_since) : ''
        })
      })
      .catch(err => {
        this.msg(err.response.data)
      })
    },
    showClosedCommunity () {
      this.isClosedCommunity = !this.isClosedCommunity
      this.loadComm()
      this.loadProjStats ()
    },
    loadProjStats () {
      this.projStats.amc = 0
      this.projStats.turnkey = 0

      var qry = {
        params: {
          vendor_id: config.VENDOR_ID
        }
      }
      this.axios.get(config.API_URL + '/getProjStatsByVendorId/', qry)
      .then(response => {
        let maintProj = response.data.find(rec => rec.proj_type === 'Maintenance')
        if (maintProj) {
          this.projStats.amc = maintProj.tot
        }
        let turnkeyProj = response.data.find(rec => rec.proj_type === 'Turnkey')
        if (turnkeyProj) {
          this.projStats.turnkey = turnkeyProj.tot
        }
        this.$forceUpdate()
      })
      .catch(err => {
        this.msg(err.response.data)
      })
    },
    getEmptyComm () {
      var emptyComm = {
        org_vendor_id: config.VENDOR_ID,
        comm_name: '',
        comm_segment: 'Medium',
        cust_since: this.today,
        address: '',
        city: '',
        contact_phone: '',
        pg_status: 'NA',
        comm_status: 'Active',
        reg_mode: 'WEB',
        zone_id: null,
        comm_type: 'Apartment',
        state: '',
        district: '',
        pan_no: '',
        gst_no: '',
        comm_img: ''
      }
      return emptyComm
    },
    prepareCreate () {
      this.lComm = this.getEmptyComm()
      this.commImgPreview = ''
      this.commImgFile = null
      this.isCommImgChanged = false
      this.lAction = 'create'
      this.loadZones()
      this.loadCountryState()
    },
    prepareEditComm (curComm) {
      this.lComm = Object.assign({}, curComm)
      // comm_img is already a full, browser-loadable URL - the backend resolves it (same as
      // facilityDailyUpdateAttach's file_url), no client-side prefixing needed
      this.commImgPreview = curComm.comm_img || ''
      this.commImgFile = null
      this.isCommImgChanged = false
      this.lAction = 'update'
      this.loadZones()
      this.loadCountryState()
    },
    pickCommImg () {
      this.$refs.commImgInput.click()
    },
    loadCommImgFromFile (event) {
      const file = event.target.files[0]
      if (!file) {
        return
      }
      const validation = handy.validateImageFile(file)
      if (validation !== true) {
        this.msg(validation)
        this.$refs.commImgInput.value = ''
        return
      }
      const fileReader = new FileReader()
      fileReader.addEventListener('load', () => {
        this.commImgPreview = fileReader.result
      })
      fileReader.readAsDataURL(file)
      this.commImgFile = file
      this.isCommImgChanged = true
      this.$refs.commImgInput.value = ''
    },
    removeCommImg () {
      this.commImgPreview = ''
      this.commImgFile = null
      this.isCommImgChanged = true
    },
    saveCommunity (action) {
      // validate and save Changes
      if (this.$refs.shForm.validate()) {
        if (config.VENDOR_ID === 1) {
          if (!this.lComm.zone_id) {
            this.msg('Please select zone name from list')
            return
          }
        }
        if (config.VENDOR_ID !== 1) {
          this.lComm.zone_id = 6
        }
        this.beingSaved = true
        var payload = Object.assign({}, this.lComm)
        if (this.isCommImgChanged) {
          // community image was added, replaced or removed - send as a base64 data-URL,
          // same format as the user avatar upload
          if (this.commImgFile) {
            payload.community_image = this.commImgPreview
          } else {
            payload.remove_community_image = true
          }
        }
        this.axios.post(config.API_URL + '/community/' + action, payload)
        .then(response => {
          // refresh the Community list
          this.lComm.comm_id = response.data.comm_id
          if (Object.prototype.hasOwnProperty.call(response.data, 'comm_img')) {
            // backend resolved a new (or removed) image to a full URL already - sync it back
            // so the list/preview don't go stale
            this.lComm.comm_img = response.data.comm_img || ''
            this.commImgPreview = this.lComm.comm_img
            this.commImgFile = null
          }
          if (action === 'update') {
            var idx = this.commList.findIndex(obj => obj.comm_id === this.lComm.comm_id)
            Object.assign(this.commList[idx], this.lComm)
          } else {
            this.commList.push(this.lComm)
          }
          this.isCommImgChanged = false
          this.lAction = 'view'
          this.loadZones()
          this.beingSaved = false
        })
        .catch(err => {
          this.msg((err.response && err.response.data) || 'Failed to save community. Please try again.')
          this.beingSaved = false
        })
      }
    },
    deleteComm (curComm) {
      if (!confirm('Sure, you want to delete the community with name "' + curComm.comm_name + '"?')) {
        return
      }
      // up in db
      this.beingSaved = true
      this.axios.post(config.API_URL + '/community/delete', curComm)
      .then(response => {
        // refresh the list
        var idx = this.commList.findIndex(obj => obj.comm_id === this.lComm.comm_id)
        this.commList.splice(idx, 1)
        this.lAction = 'view'
        this.beingSaved = false
      })
      .catch(err => {
        this.msg(err.response.data)
        this.beingSaved = false
      })
    },
    createZones () {
      this.lZone = {
        zone_name: '',
        vendor_id: config.VENDOR_ID
      }
      this.lZAction = 'create'
    },
    prepareCreateZone () {
      this.createZone = true
      this.lZAction = 'view'
      this.loadZones()
    },
    cancelChanges () {
      this.lZAction = 'view'
    },
    saveZone () {
      // validate and save Changes
      if (this.$refs.acForm.validate()) {
        this.beingSaved = true
        this.lZone.vendor_id = config.VENDOR_ID
        this.axios.post(config.API_URL + '/zone/' + this.lZAction, this.lZone)
        .then(response => {
          // refresh the zone list
          this.loadZones()
          this.lZAction = 'view'
          this.beingSaved = false
        })
        .catch(err => {
          this.msg(err.response.data)
          this.beingSaved = false
        })
      }
    },
    loadZones () {
      var qry = {
        params: {
          vendor_id: config.VENDOR_ID
        }
      }
      this.axios.get(config.API_URL + '/getAllZones/', qry)
      .then(response => {
        this.zoneList = response.data
      })
      .catch(err => {
        this.msg(err, 0)
        this.zoneList = []
      })
    },
    prepareEdit (curZone) {
      this.lZone = Object.assign({}, curZone) // keep the original object safely before changes
      this.lZAction = 'update'
    },
    deleteZone (curZone) {
      if (!confirm('Sure, you want to delete the zone "' + curZone.zone_name + '"?')) {
        return
      }
      this.beingSaved = true
      this.axios.post(config.API_URL + '/zone/delete', curZone)
      .then(response => {
        this.loadZones()
        this.lZAction = 'view'
        this.beingSaved = false
      })
      .catch(err => {
        this.msg(err.response.data)
        this.beingSaved = false
      })
    },
    loadCountryState () {
      this.axios.get(config.API_URL + '/getCountryStateList/')
      .then(response => {
        this.countryState = response.data
      })
      .catch(err => {
        this.msg(err, 0)
      })
    }
  }
}
</script>

<style scoped>
.comm-img-preview {
  width: 180px;
  height: 180px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px dashed #bdbdbd;
}
.comm-img-preview-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.comm-img-hint {
  font-size: 11px;
}
</style>
